module.exports = __webpack_public_path__ + "static/media/002.f40f31ee.JPG";